module.exports = "<div #modalContainer></div>\n<div class=\"toast-container\">\n  <div #toastContainer></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /dist/src/app/notify/notify-container/notify-container.component.html
// module id = ../../../../../src/app/notify/notify-container/notify-container.component.html
// module chunks = main